export var RaceTypeEnum;
(function (RaceTypeEnum) {
    RaceTypeEnum[RaceTypeEnum["BASE_RACE"] = 1] = "BASE_RACE";
    RaceTypeEnum[RaceTypeEnum["SUB_RACE"] = 2] = "SUB_RACE";
    RaceTypeEnum[RaceTypeEnum["VARIANT"] = 3] = "VARIANT";
})(RaceTypeEnum || (RaceTypeEnum = {}));
